// extracted by mini-css-extract-plugin
export default {"vip":"vip_vip__YPNDL","vip__inner":"vip_vip__inner__p9cJz","vip__grid__characteristics":"vip_vip__grid__characteristics__AjbJm","vip__grid":"vip_vip__grid__ceZ2p"};